import papoReto from "./papoReto";
import caindoNaLua from "./caindoNaLua";
import saborDoSom from "./saborDoSom";

const allTexts = [papoReto, caindoNaLua, saborDoSom];

export default allTexts;
